import * as Yup from "yup";
export const initialValues = (data) => {
  return {
    ...data,
    englishTagName: data?.localized_data?.en?.name,
    arabicTagName: data?.localized_data?.ar?.name,
    image: data?.image,
  };
};
export const structure = (_, __, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: t("lookups_tags.image"),
        width: "100%",
      },
      {
        name: `englishTagName`,
        kind: "input",
        type: "text",
        label: `${t("lookups_tags.english_tag")}*`,
        width: "47%",
      },
      {
        name: `arabicTagName`,
        kind: "input",
        type: "text",
        label: `${t("lookups_tags.arabic_tag")}*`,
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    englishTagName: Yup.string().required("required"),
    arabicTagName: Yup.string().required("required"),
    image: Yup.mixed(),
  });
